<template>
  <main class="mx-auto p-2">

    <!-- WX Token 设置 -->
    <div class="mb-2 max-w-2xl mx-auto flex items-center gap-2">
      <label class="text-sm font-medium">wxLoginToken:</label>
      <input
          type="text"
          v-model="inputToken"
          placeholder="请输入 wxLoginToken"
          class="border rounded px-2 py-1 flex-1"
      />
      <button
          @click="setToken"
          class="px-3 py-1 bg-indigo-600 text-white rounded hover:bg-indigo-700"
      >
        设置
      </button>
    </div>

    <div class="flex flex-row">
      <!-- 搜索栏 -->
      <div class="left-box">
        <SearchBar
            :previewUrl="picUrl"
            @search="handleSearch"
            ref="searchBar"
            @hh-changed="handleHhChanged"
        />
      </div>

      <div class="flex-1 right-box">
        <div v-if="spuId !== 0">
          <ProductDetail
              ref="productDetail"
              :spu-id="spuId"
              :query-info="queryInfo"
              :refresh-search="refreshSearchBar"
          />
        </div>

        <!-- 搜索结果列表 -->
        <section
            v-if="showResults && productList.length"
            class="pt-6 grid grid-results gap-4 sm:gap-6 border-t"
        >
          <ProductCard
              ref="productCard"
              v-for="product in productList"
              :key="product.productId"
              :product="product"
              :wx-login-token="wxLoginToken"
              @open="handleOpenDetail"
          />
        </section>

        <!-- 无结果提示 -->
        <div v-if="showResults && !productList.length && !loading" class="text-center mt-4 text-gray-500">
          没有搜索到相关商品
        </div>

        <!-- 加载状态 -->
        <div v-if="loading" class="text-center mt-4">
          正在加载...
        </div>
      </div>
    </div>

  </main>
</template>

<script>
import SearchBar from '../components/SearchBar.vue'
import ProductCard from '../components/ProductCard.vue'
import ProductDetail from './ProductDetail.vue'
import { searchDewuByPic, getFirstDownloadUrl } from '../api/dewu.js'

const TOKEN_KEY = 'wxLoginToken'

export default {
  name: 'HomeView',
  components: { SearchBar, ProductCard, ProductDetail },
  data() {
    return {
      inputToken: '',
      wxLoginToken: '',
      picUrl: '',           // 响应式 picUrl
      productList: [],
      showResults: false,
      loading: false,
      spuId: 0,
      queryInfo: { title: '', hh: '', img: '' }
    }
  },
  created() {
    const savedToken = localStorage.getItem(TOKEN_KEY)
    if (savedToken) {
      this.wxLoginToken = savedToken
      this.inputToken = savedToken
    }
    this.fetchDefaultPicUrl()
  },
  methods: {

    /** 当货号发生变化时 */
    handleHhChanged({downloadUrl }) {
      // 清空 ProductDetail 数据
      if (this.$refs.productDetail) {
        this.$refs.productDetail.reset?.()
      }

      // 清空所有 ProductCard 组件
      if (this.$refs.productCard) {
        if (Array.isArray(this.$refs.productCard)) {
          this.$refs.productCard.forEach(card => card.reset?.())
        } else {
          this.$refs.productCard.reset?.()
        }
      }
      // 使用新的图片 URL 进行搜索
      console.log('货号变化，使用新图片 URL 搜索:', downloadUrl)
      this.handleSearch(downloadUrl)
    },

    setToken() {
      if (!this.inputToken.trim()) {
        alert('请输入有效的 wxLoginToken')
        return
      }
      this.wxLoginToken = this.inputToken.trim()
      localStorage.setItem(TOKEN_KEY, this.wxLoginToken)
      alert('wxLoginToken 已设置成功')
    },

    async fetchDefaultPicUrl() {
      try {
        const url = await getFirstDownloadUrl()
        if (!url) console.warn('未获取到默认图片 URL')
        this.picUrl = url
      } catch (e) {
        console.error('获取默认图片失败:', e)
      }
    },

    mapProduct(item) {
      return {
        productId: item.productId,
        spuId: item.spuId,
        articleNumber: item.articleNumber || '',
        title: item.title || '',
        images: item.images && item.images.length ? item.images : [this.picUrl],
        price: item.price || item.minSalePrice || 0,
        material: item.detailExtMap?.material || '',
        onlookers: item.onlookers || 0
      }
    },

    async handleSearch(picUrlFromSearchBar) {
      if (!this.wxLoginToken) return alert('请先设置 wxLoginToken')
      if (!picUrlFromSearchBar) return alert('图片未准备好，请稍后重试')

      // ✅ 只在点击搜索时清空 ProductDetail
      if (this.$refs.productDetail) {
        this.$refs.productDetail.reset()
        await this.$refs.productDetail.refreshFirstItem() // 重新加载 firstItem
      }
      if (this.$refs.productCard) { if (Array.isArray(this.$refs.productCard)) { this.$refs.productCard.forEach(card => card.reset?.()) } else { this.$refs.productCard.reset?.() } }

      this.loading = true
      this.showResults = false

      try {
        const res = await searchDewuByPic(picUrlFromSearchBar, this.wxLoginToken)
        this.productList = Array.isArray(res?.data?.productList)
            ? res.data.productList.map(this.mapProduct)
            : []
        this.showResults = true
        const firstItem = this.productList[0]
        if (firstItem) {
          this.handleOpenDetail({
            spuId: firstItem.spuId,
            queryInfo: {
              title: firstItem.title || '',
              hh: firstItem.articleNumber || '',
              img: firstItem.images?.[0] || ''
            }
          })
        }
      } catch (error) {
        console.error('搜索失败:', error)
        this.productList = []
        this.showResults = true
      } finally {
        this.loading = false
      }
    },

    handleOpenDetail(data) {
      this.spuId = 0
      this.queryInfo = { title: '', hh: '', img: '' }
      this.$nextTick(() => {
        this.spuId = data.spuId
        this.queryInfo = data.queryInfo || { title: '', hh: '', img: '' }
      })
    },

    // 传给 ProductDetail 的刷新方法
    refreshSearchBar: async function (options = { onlyFirstItem: false }) {
      if (!this.$refs.searchBar) return

      if (options.onlyFirstItem) {
        // 只刷新 firstItem，不触发搜索
        await this.$refs.searchBar.loadFirstItem()
      } else {
        // 点击搜索时才触发搜索
        await this.$refs.searchBar.triggerSearch()
      }
    }

  }
}
</script>

<style scoped>
.grid-results {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 1rem;
}
.left-box {
  width: 320px;
}
.right-box {
  max-height: calc(100vh - 62px);
  overflow-y: auto;
}
</style>
